<template>
  <div :class="['game_step', elClass]"></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  answered: {
    type: Boolean,
    default: false,
  },
  correct: {
    type: Boolean,
    default: false,
  },
  totalRounds: {
    type: Number,
    default: 0,
  },
});

const isCentered = computed(() =>
  (props.index > 0) &&
  (props.index < (props.totalRounds - 1)),
);

const isCorrect = computed(() => props.answered && props.correct);

const isWrong = computed(() => props.answered && !props.correct);

const elClass = computed(() => ({
  centered: isCentered.value,
  correct: isCorrect.value,
  wrong: isWrong.value,
}));
</script>
